import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  TrackByFunction,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompletionMessage, FileUpload } from '@app-libs/model';
import { MessageItemComponent } from '../message-item/message-item.component';
import { ChatStateService } from '../../../../services/chat/chat-state.service';

@Component({
  selector: 'app-message-list',
  standalone: true,
  imports: [CommonModule, MessageItemComponent],
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss'],
  // Removed OnPush for streaming compatibility
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageListComponent {
  @Input() messages: CompletionMessage[] = [];
  @Input() activeMessageId: string | null = null;
  @Input() copiedMessageId = '';
  @Input() exportedMessageId = '';

  @Output() copySuccess = new EventEmitter<CompletionMessage>();
  @Output() exportSuccess = new EventEmitter<CompletionMessage>();
  @Output() exportError = new EventEmitter<{ message: CompletionMessage; error: string }>();
  @Output() messageEnter = new EventEmitter<string | null>();
  @Output() messageLeave = new EventEmitter<void>();
  @Output() messageClick = new EventEmitter<CompletionMessage>();
  @Output() messageMouseDown = new EventEmitter<CompletionMessage>();
  @Output() messageMouseUp = new EventEmitter<CompletionMessage>();
  @Output() deleteFile = new EventEmitter<FileUpload>();

  constructor(private chatStateService: ChatStateService) {}

  trackByMessageId: TrackByFunction<CompletionMessage> = (index: number, message: CompletionMessage) => {
    return message.message_id || index;
  };

  /**
   * Check if a message is currently streaming
   */
  isMessageStreaming(message: CompletionMessage, index: number): boolean {
    // Check if this is the last message and if streaming is active
    const isLastMessage = index === this.messages.length - 1;
    const isAssistantMessage = message.role === 'assistant';
    const isCurrentlyStreaming = this.chatStateService.isStreaming;
    
    return isLastMessage && isAssistantMessage && isCurrentlyStreaming;
  }

  onCopySuccess(message: CompletionMessage): void {
    this.copySuccess.emit(message);
  }

  onExportSuccess(message: CompletionMessage): void {
    this.exportSuccess.emit(message);
  }

  onExportError(event: { message: CompletionMessage; error: string }): void {
    this.exportError.emit(event);
  }

  onMessageEnter(messageId: string | null): void {
    this.messageEnter.emit(messageId);
  }

  onMessageLeave(): void {
    this.messageLeave.emit();
  }

  onMessageClick(message: CompletionMessage): void {
    this.messageClick.emit(message);
  }

  onMessageMouseDown(message: CompletionMessage): void {
    this.messageMouseDown.emit(message);
  }

  onMessageMouseUp(message: CompletionMessage): void {
    this.messageMouseUp.emit(message);
  }

  onDeleteFile(file: FileUpload): void {
    this.deleteFile.emit(file);
  }
}
